import { taeSettingsSource } from '@oc/pages/settings/TimesheetSettings/home/data/taeSettingsSource';

export const settingsSources = [taeSettingsSource];
